import { Inject, Injectable } from '@angular/core';
import { NxMomentDateAdapter } from '@aposin/ng-aquila/moment-date-adapter';
import { NX_DATE_LOCALE } from '@aposin/ng-aquila/datefield';
import moment from 'moment';

@Injectable()
export class MyDateAdapter extends NxMomentDateAdapter {
  constructor(
    @Inject(NX_DATE_LOCALE) dateLocale: string,
    ) {
    super(dateLocale);
  }

  override parse(value: any, parseFormat: string | string[], strict: boolean): moment.Moment | null {
    if (value && typeof value === 'string') {
      const date = moment.utc(value, parseFormat, strict);
      return date.isValid() ? date : null;
    }
    return super.parse(value, parseFormat, strict);
  }
}

export const MY_FORMATS = {
  parse: {
    dateInput: ['DD/MM/YYYY', 'D/MM/YYYY', 'DD/M/YYYY', 'D/M/YYYY'],
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
